import { render, staticRenderFns } from "./TeacherEduTeacher.vue?vue&type=template&id=63f5ddbc&scoped=true&"
import script from "./TeacherEduTeacher.vue?vue&type=script&lang=js&"
export * from "./TeacherEduTeacher.vue?vue&type=script&lang=js&"
import style0 from "./TeacherEduTeacher.vue?vue&type=style&index=0&id=63f5ddbc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f5ddbc",
  null
  
)

export default component.exports